/**
 * Která projektová operace je STAV, a která už jen historie?
 *
 * Filip 2026-09-10: „tohle je zlej sen" — workspace mu ukazoval chybu ze
 * synchronizace, která selhala PŘEDCHOZÍ DEN, a nabízel k ní „Zkusit znovu",
 * přestože stejná operace mezitím několikrát v pořádku doběhla. Vypadalo to
 * jako živá porucha platformy; přitom to byl nález ze seznamu.
 *
 * Příčina: obrazovky si braly PRVNÍ operaci se stavem queued/running/failed.
 * Seznam ale není řazený podle vzniku a selhaná operace v něm zůstane napořád,
 * takže se každým otevřením stránky vzkřísila nejstarší chyba, jakou kdo kdy
 * viděl.
 *
 * Pravidlo: rozhoduje NEJNOVĚJŠÍ operace svého druhu. Běžící se ukáže vždy;
 * selhaná jen tehdy, když je nejnovější — jakmile po ní přišla další, je to
 * selhání překonané a patří do historie, ne na obrazovku.
 */

export interface LifecycleOperationLike {
  id: string;
  status: string;
  created_at?: string | null;
  error?: string | null;
}

const STALE_RESTART = 'ACM restart — stale project executor';

/** Kdy operace vznikla; bez údaje 0, takže rozhodne pořadí ze serveru. */
function createdAt(operation: LifecycleOperationLike): number {
  const parsed = operation.created_at ? Date.parse(operation.created_at) : Number.NaN;
  return Number.isNaN(parsed) ? 0 : parsed;
}

export function pickLiveOperation<T extends LifecycleOperationLike>(
  operations: readonly T[] | undefined,
  opts: { matches: (operation: T) => boolean; live: readonly string[] },
): T | null {
  const candidates = (operations ?? []).filter(opts.matches);
  if (candidates.length === 0) return null;
  const newest = candidates.reduce((best, candidate) =>
    createdAt(candidate) > createdAt(best) ? candidate : best
  );
  // Restart ACM přeruší executor a zapíše failed. To není porucha Gitu —
  // jen přerušení. Na obrazovku nepatří (keen-comet-3e9f, 10. 9. 2026).
  if (newest.status === 'failed' && newest.error === STALE_RESTART) return null;
  return opts.live.includes(newest.status) ? newest : null;
}
